import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../../admin.service';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
@Component({
    selector: 'app-create-banner',
    templateUrl: './create-banner.html',
    styleUrls: ['./create-banner.css', '../list-banner/list-banner.css']
})

export class CreateBanner implements OnInit {
    selectedShedule = 'daily'
    minEndDate = new Date();
    isImageToggle = false;
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    selectedImageName = "";
    selectedTimeInComponent = 'minutes';
    bannnerName = "";
    bannerDesignForm: FormGroup;
    scheduleBanner: FormGroup;
    redirectUrl = "";
    imageSelected = '';
    startTime = '';
    endTime = '';
    typeOfBanner = '';
    previewObj: any;
    isPreviewShow = false;
    bannerId = '';
    bannerDetails: any;
    bannerType = '';
    isButtonToggle = false;
    isTimerToggle = false;
    startDateForm = new FormControl();
    endDateForm = new FormControl();
    s3UrlForImage = ''
    allBannerTypes = [{name : "Live Quiz", value : "LIVE_QUIZ"}, {name : "Competition Zone", value : "COMPETITION_ZONE"}, {name : "Bot", value : "BOT"}, {name : "Rewards", value : "REWARDS"}, {name : "Digital Class", value : "DIGITAL_CLASS"}, {name : "Skills Corner", value : "SKILLS_CORNER"}]
    ngOnInit(): void {
        this.bannerDesignForm = this._formBuilder.group({
            mediaUrl: [''],
            buttonText: [''],
            timer: [''],
            smallText: [''],
            largeText: ['', [Validators.required, Validators.minLength(14)]]
        });
        this.scheduleBanner = this._formBuilder.group({
            startDate: ['', [Validators.required]],
            endDate: ['', [Validators.required]],
        })
        this.bannerId = this.activatedRoute.snapshot.params.bannerId;
        if (this.bannerId != 'new')
            this.getBannerDetails();
    }
    constructor(
        private _snackBar: MatSnackBar,
        private _formBuilder: FormBuilder,
        private adminService: AdminService,
        private router: Router,
        private activatedRoute: ActivatedRoute) { }

    fillFormForEditBanner() {
        this.bannerDesignForm.patchValue({
            smallText: this.bannerDetails.title,
            largeText: this.bannerDetails.body,
        })
        this.bannnerName = this.bannerDetails.name;
        this.redirectUrl = this.bannerDetails.deep_link;
        if ('button_text' in this.bannerDetails && this.bannerDetails.button_text) {
            this.bannerDesignForm.patchValue({
                buttonText: this.bannerDetails.button_text
            })
            this.isButtonToggle = true;
        }
        if ('icon' in this.bannerDetails && this.bannerDetails.icon) {
            const parts = this.bannerDetails.icon.split('/');
            const extractedValue = parts[parts.length - 1];

            this.bannerDesignForm.patchValue({
                mediaUrl: extractedValue
            })
            this.s3UrlForImage = this.bannerDetails.icon;
            this.selectedImageName = extractedValue;
            this.isImageToggle = true;
        }
        if ('timer_duration' in this.bannerDetails && this.bannerDetails.timer_duration) {
            this.bannerDesignForm.patchValue({
                timer: this.bannerDetails.timer_duration/60
            })
            this.isTimerToggle = true;
        }
        this.startTime = this.bannerDetails.start_time.slice(0, 5);
        this.endTime = this.bannerDetails.end_time.slice(0, 5);
        this.bannerType = this.bannerDetails.type;
        this.startDateForm.setValue(new Date(this.bannerDetails.start_date));
        this.endDateForm.setValue(new Date(this.bannerDetails.end_date));
        this.scheduleBanner.patchValue({
            startDate: this.bannerDetails.start_date,
            endDate: this.bannerDetails.end_date
        })
    }
    getBannerDetails() {
        this.adminService.getBannerDetails(this.bannerId).subscribe(
            (res) => {
                this.bannerDetails = res;
                this.fillFormForEditBanner();
            }
        )
    }
    onToggleChange(event, type) {
        if (type === 'image')
            this.isImageToggle = event.checked;
        else if(type === 'button')
            this.isButtonToggle = event.checked;
        else if(type === 'timer')
            this.isTimerToggle = event.checked;
    }

    uploadImage(event) {
        let file = event.target.files[0];
        if (file && this.validateUploadImage(file)) {
            this.adminService.addBannerIcon().subscribe(
                async (res) => {
                    this.adminService.uploadImageToS3(file, res).subscribe((response)=>{this.s3UrlForImage = response.url+'/banner-notification/'+res.icon_id },(error)=>console.log(error))
                    this.imageSelected = file;
                    this.selectedImageName = file.name;
                    this.bannerDesignForm.patchValue({
                        mediaUrl: res.icon_id
                    })
                },
                (err) => {
                    let message = err.error.message;
                    message = message ? message : "Something Went Wrong"
                    this._snackBar.open(message, 'close', {
                        duration: 3000,
                        horizontalPosition: this.horizontalPosition,
                    }
                    )
                })
        }
    }

    validateUploadImage(file) {
        if (file.size > 1000000) {
            this._snackBar.open("Image is greater than 1MB", 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
            return false;
        }
        if (file.type == 'image/png') {
            return true;
        }
        else {
            this._snackBar.open(`Invalid image type ${file.type}`, 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
            return false;
        }

    }
    deleteInputImage() {
        this.selectedImageName = "";
        this.bannerDesignForm.patchValue({
            mediaUrl: ""
        })
        this.imageSelected = '';
    }
    onStartDateChange(event) {
        console.log(event);
        this.scheduleBanner.patchValue({
            startDate: event.value
        })
    }
    onEndDateChange(event) {
        this.scheduleBanner.patchValue({
            endDate: event.value
        })
    }


    prevewBanner() {
        if (this.validateAllFields()) {
            this.isPreviewShow = true;
            let timer = 0;
            if (this.isTimerToggle) {
                if (this.selectedTimeInComponent == 'hours')
                    timer = this.bannerDesignForm.controls['timer'].value * 60;
                else
                    timer = this.bannerDesignForm.controls['timer'].value
            }
            this.previewObj = {
                smallText: this.bannerDesignForm.controls['smallText'].value,
                largeText: this.bannerDesignForm.controls['largeText'].value,
                isImageToggle: this.isImageToggle,
                isButtonToggle: this.isButtonToggle,
                isTimerToggle: this.isTimerToggle,
                buttonText: this.bannerDesignForm.controls['buttonText'].value,
                imageUrl: this.s3UrlForImage,
                timer: timer
            }
        }
        else {
            this.isPreviewShow = false;
        }
    }
    timeToMillisecond(time) {
        let [hours, minutes] = time.split(':');
        let milliSecond = (parseInt(hours, 10) * 60 + parseInt(minutes, 10)) * 60 * 1000;
        return milliSecond;
    }
    validateDateandTime() {
        if (!this.startTime || !this.endTime) {
            return { isValid: false, message: 'Active until or Active From is empty' }
        }
        let start_time = this.timeToMillisecond(this.startTime);
        let end_time = this.timeToMillisecond(this.endTime);
        // if (start_time >= end_time) {
        //     return { isValid: false, message: 'Active from  is greater than Active until' }
        // }
        let start_date = new Date(this.scheduleBanner.controls['startDate'].value).getTime() + start_time;
        let end_date = new Date(this.scheduleBanner.controls['endDate'].value).getTime() + end_time;
        if (start_date > end_date) {
            return { isValid: false, message: 'start date and time cannot be greater than end date and time' }
        }
        if (this.isButtonToggle) {
            if (!this.bannerDesignForm.controls['buttonText'].value) {
                return { isValid: false, message: 'Button toggle is on..But button text is empty' }
            }
        }
        if (this.isTimerToggle) {
            if (!this.bannerDesignForm.controls['timer'].value) {
                return { isValid: false, message: 'Timer toggle is on..But timer text is empty' }
            }
        }
        if (this.isImageToggle && !this.bannerDesignForm.controls['mediaUrl'].value) {
            return { isValid: false, message: 'Image toggle is on..But Image not selected' }

        }
        return { isValid: true, message: "Valid Date" };
    }
    validateAllFields() {
        let message = '';
        if (!this.bannnerName) {
            message = 'Banner Name is Required'
        }
        else if (!this.redirectUrl) {
            message = 'Redirect Url is required';
        }
        else if (!this.bannerType) {
            message = "Banner Type is Required"
        }
        else if (!this.validateDateandTime().isValid) {
            message = this.validateDateandTime().message;
        }
        else if (!this.scheduleBanner.valid || !this.bannerDesignForm.valid) {
            if(this.bannerDesignForm.controls['smallText'].value.length<14)
             message = "Small Text Must Be 14 character long";
            else
             message = 'Some required filled is empty';
        }
        if (message) {
            this._snackBar.open(message, 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition
            })
            return false;
        }
        else {
            return true;
        }
    }
    publishBanner() {
        let data = [];
        let reqBody = {
            name: this.bannnerName,
            status: 'ACTIVE',
            start_date: this.getFormatedDate(this.scheduleBanner.controls['startDate'].value),
            end_date: this.getFormatedDate(this.scheduleBanner.controls['endDate'].value),
            start_time: this.startTime,
            end_time: this.endTime,
            title: this.previewObj.smallText,
            body: this.previewObj.largeText,
            deep_link: this.redirectUrl,
            type: this.bannerType
        }
        if (this.previewObj.isImageToggle)
            reqBody['icon'] = this.bannerDesignForm.controls['mediaUrl'].value;

        if (this.previewObj.isButtonToggle)
            reqBody['button_text'] = this.previewObj.buttonText;
        if (this.previewObj.isTimerToggle)
            reqBody['timer_duration'] = this.previewObj.timer * 60;

        data.push(reqBody);
        if (this.bannerId && this.bannerId!='new') {
            this.adminService.updateBanner(reqBody, this.bannerId).subscribe(
                (res)=>{
                    this.router.navigateByUrl('/admin/banners/list-banner');
                },
                (err)=>{
                    this.router.navigateByUrl('/admin/banners/list-banner');
                }
            );
        } else {
            this.adminService.addNewBanner({ data }).subscribe(
                (res) => {
                    this._snackBar.open("Banner SuccessFully posted", 'close', {
                        duration: 3000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                    });
                    this.router.navigateByUrl('/admin/banners/list-banner');
                },
                (err) => {
                    let message = "Something Went Wrong";
                    if (err.error.message)
                        message = err.error.message
                    this._snackBar.open(message, 'close', {
                        duration: 3000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                    });
                }
            )
        }


    }
    getFormatedDate(inputDateStr) {
        const inputDate = new Date(inputDateStr);
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

}
